import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../../../services/apiServices";
import { endPoints } from "../../../configs/apiUrls";



interface ProprtyTypeListResponse {
    filterData: any;
    data: any;
}

interface FetchPropertyListParams {
    page?: number;
    limit?: number;
    state?: string;
    city?: string;
    search?: string;
    sortBy?: string | null;
    sortOrder?: "asc" | "desc" | null;
    isActive?: boolean | null;
}

export const fetchPropertyForSale = createAsyncThunk<ProprtyTypeListResponse, FetchPropertyListParams>(
    "propertiesForSale/fetchPropertyForSale",
    async (
        {
            page = 1,
            limit = 10,
            state = "",
            city = "",
            search = "",
            sortBy = null,
            sortOrder = null,
            isActive = null,
        },
        thunkAPI
    ) => {
        try {
            // Only include isActive if a boolean was provided, NOT null
            const params = {
                page,
                limit,
                state: state || undefined,
                city: city || undefined,
                search: search || undefined,
                sortBy: sortBy || undefined,
                sortOrder: sortOrder || undefined,
                ...(isActive !== null && isActive !== undefined ? { isActive } : {})
            };
            const response = await apiGet(endPoints.PROPERTIES_FOR_SALE, params);
            
            return {
                data: response.data,
                filterData: {
                    isActive,
                    state,
                    city,
                    search,
                    page: response.page,
                    limit: response.limit,
                    totalCount: response.total,
                    sortBy,
                    sortOrder,
                },
                success: response.success,
                page: response.page,
                limit: response.limit,
                total: response.total,
                totalPages: response.totalPages,
            };
        } catch (error) {
            console.error("❌ API error", error);
            return thunkAPI.rejectWithValue("Failed to fetch area list");
        }
    }
);

export const fetchPropertyForSaleById = createAsyncThunk(
    "propertiesForSale/fetchPropertyForSaleById",
    async (userId: string, thunkAPI) => {
        try {
            const response = await apiGet(`${endPoints.PROPERTIES_FOR_SALE}/${userId}`,);
            // Assuming apiGet returns { success, data, ... }
            return response.data;
        } catch (error: any) {
            console.error("❌ API error", error);
            return thunkAPI.rejectWithValue("Failed to fetch properties for this user");
        }
    }
);


